import type { IOrganizationGetOne } from '../../interfaces/organizationGetOne';
import { getFormattedAddress } from '../../../../common/utils/getFormattedAddress';
import { translateKey } from '../../../translate';

export function OrganizationBlock(props: { organization: IOrganizationGetOne }) {
    return (
        <>
            <h3>{props.organization.name}</h3>
            <ul>
                {getFormattedAddress(props.organization) && (
                    <li>
                        {translateKey('organization.address')} : {getFormattedAddress(props.organization)}
                    </li>
                )}

                {props.organization.zip && (
                    <li>
                        {translateKey('common.zipcode')} : {props.organization.zip}
                    </li>
                )}

                {props.organization.city && (
                    <li>
                        {translateKey('common.city')} : {props.organization.city}
                    </li>
                )}

                {props.organization.state && (
                    <li>
                        {translateKey('common.state')} : {props.organization.state}
                    </li>
                )}

                {props.organization.country && (
                    <li>
                        {translateKey('common.country')} : {props.organization.country}
                    </li>
                )}

                {props.organization.phoneNumber && (
                    <li>
                        {translateKey('common.phoneNumber')} : {props.organization.phoneNumber}
                    </li>
                )}

                {props.organization.organizationType && (
                    <li>
                        {translateKey('common.type')}:{' '}
                        {translateKey('organizationTypeEnum.' + props.organization.organizationType)}
                    </li>
                )}
            </ul>
        </>
    );
}
